import { createSlice } from "@reduxjs/toolkit";
import { createEncryptedAsyncThunk } from "../../Utility/APIUtils";

const initialState = {
  dmtSuccess: false,
  creditAmountResponse: {
    error: false,
    message: "",
  },
  commonDeleteResponse: {
    status: false,
    message: "",
  },
  commonDeleteSucces: false,
  error: "",
  loading: false,
};

export const transactionProcess = createEncryptedAsyncThunk(
  "dmtSlice/transactionProcess",
  "transaction/CreateDMTTransaction",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.data.serviceId.serviceId,
      wallettype: 1,
      // beneficiary_ID: params.data.beniDetails.benificiary_Id,
      beneficiary_ID: params.data.beniDetails.id,
      bank_ID: params.data.beniDetails.bank_id,
      amount: Number(params.data.transactionAmount),
      service_Charges: Number(params.data.transactionAmuntCharges),
      total_Amount: Number(params.data.transactionAmount),
      tpin: params.tPin.tPin,
      paysprintRequest: {
        otp: params.OTP || "",
        otp_reference: params.transOtpRefId || "",
      },
      transfer_Type: params.taxn_type,
      latitude: `${params.lat}`,
      longitude: `${params.lng}`,
       // status: 0,
      // created_By: 0,
      // created_Date: "2024-02-24T15:23:06.189Z",
      // mobileNo: params.Mobile.customerMobileNumber,
      // cust_ID: params.data.beniDetails.cust_id,
      // commision_ID: 0,
      // account_No: params.data.beniDetails.accountnumber,
      // dmT_ID: 0,
    }),
  }
);
export const transactionProcessISRU = createEncryptedAsyncThunk(
  "dmtSlice/transactionProcessISRU",
  "account/ISU_CreateMoneyTransfer_Wb",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.data.serviceId.serviceId,
      wallettype: 1,
      beneficiary_ID: params.data.beniDetails.benificiary_Id,
      service_Charges: Number(params.data.transactionAmuntCharges),
      total_Amount: Number(params.data.transactionAmount),
      requestedAmount: Number(params.data.transactionAmount),
      isHoldTransaction: false,
      tpin: params.tPin.tPin,
      txn_mode: "DMT",
      txn_type: params.data.selected,
      username: "",
    }),
  }
);
export const transactionProcessPayout = createEncryptedAsyncThunk(
  "dmtSlice/transactionProcessPayout",
  "account/CashTransfer_Payout",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => {
      const list = {
        userID: params.currentUser.userGuid,
        serviceId: params.data.serviceId.serviceId,
        wallettype: 1,
        beneficiary_ID: params.data.beniDetails.id,
        tpin: params.tPin.tPin,
        service_Charges: Number(params.data.transactionAmuntCharges),
        total_Amount: Number(params.data.transactionAmount),
        amount: Number(params.data.transactionAmount),
        fundTransferType: params.taxn_type,
        latlong: `${params.location.lattitude}, ${params.location.longitude}`,
        custIpAddress: params.location.ip,
        rP_CallbackURL: process.env.REACT_APP_PAYOUT_CALLBACKURL,
        txntype: "PAYOUT",
        // digikhatA_InitiateTransactionInputRequest: params.digikhataReq
        // transfer_Type: params.taxn_type,
      }
      if (params.digikhataReq) {
        list.digikhatA_InitiateTransactionInputRequest = params.digikhataReq
      }
      return list
    },
  }
);
export const getTransactionDetails = createEncryptedAsyncThunk(
  "dmtSlice/getTransactionDetails",
  "transaction/GetServiceUsageDetails",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.serviceId.serviceId,
      amount: Number(params.transactionAmount),
    }),
  }
);
export const getTransactionReciept = createEncryptedAsyncThunk(
  "dmtSlice/getTransactionReciept",
  "account/GetDMTTransaction",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      dmt_transaction_userid: params.currentUser.userId,
      txn_id: params.TransactionID,
      status: [0],
      txn_type: params.txn_type || '',
      startDate: params.startDate || null,
      endDate: params.endDate || null,
    }),
  }
);
export const getISUTransactionReciept = createEncryptedAsyncThunk(
  "dmtSlice/getISUTransactionReciept",
  "account/ISU_IMPSLite_TxnReport",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      _1: "DMT_txn_status_api",
      _4: params.currentDate,
      _5: params.currentDate,
      _6: params.referenceid,
      _10: params.TransactionID,
    }),
  }
);
export const dmt = createSlice({
  name: "dmt",
  initialState,
  reducers: {
    creditAmountSuccess(state) {
      return { ...state, creditAmountSucess: true };
    },
    creditAmountFailed(state, action) {
      return {
        ...state,
        creditAmountResponse: { error: true, message: action.payload },
      };
    },
    FetchSuccess(state, action) {
      return { ...state, recharge: action.payload.Data[0] };
    },
    FetchFailed(state, action) {
      return {
        ...state,
        rechargeResponse: { status: true, message: action.payload },
      };
    },
    DeleteSuccess(state) {
      return { ...state, loading: false, commonDeleteSucces: true };
    },
    DeleteFailed(state, action) {
      return {
        ...state,
        fetchError: false,
        commonDeleteResponse: { status: true, message: action.payload },
      };
    },
    DeleteInitial(state) {
      return {
        ...state,
        commonDeleteSucces: false,
        commonDeleteResponse: { status: false, message: "" },
      };
    },
  },
});
export const {
  creditAmountSuccess,
  creditAmountFailed,
  FetchSuccess,
  FetchFailed,
  DeleteSuccess,
  DeleteFailed,
  DeleteInitial,
} = dmt.actions;
export default dmt.reducer;
